import React from 'react'; 
import { TextField, Grid, Avatar, MenuItem, Select, Fab, Switch,} from '@material-ui/core';
import Utils from '../providers/Utils';
import LocalStorage from '../providers/LocalStorage';
import PropTypes from 'prop-types';
import Menu from '../commons/Menu'
import Calendar from 'react-calendar';
import ro from 'date-fns/locale/ro';
// import en from 'date-fns/locale/en'

export default class DocumenteList extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            strSearchString:'',
            elementeAfisate:[]
            
        } 
    }



    componentDidMount(){
       this.setState({ elementeAfisate:this.props.elemente || []})
    }


    componentWillReceiveProps(nextProps){
        this.setState({
            elementeAfisate:nextProps.elemente || [],
        })
    }

    getLitereAvatar = (tx)=>{

        if(tx !== null){

            return tx.substring(0,1).toUpperCase()
        }
    }

    // filterFunc = (ev) => {

    //     this.setState({strSearchString:ev.target.value})
    //     let e = [...this.props.elemente]

    //     e = e.filter(x=>{
            
    //         if( (x[this.props.onlyColumns.nume]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
    //             return true
            
    //         if( (x[this.props.onlyColumns.description]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
    //             return true
            
    //         return false

    //     })

    //     this.setState({elementeAfisate: e})
    // }

    render(){
        return (
            <div style={this.props.style} className='pm-users-list-container'>
                       

                <TextField className='inputFocus' label={this.props.dict.comune.search} onChange={this.filterFunc} value={this.state.strSearchString} />
                <ul style={{cursor:'pointer', position:'relative', padding:0, minWidth:'100%'}} className='pm-list-container'>
                <li className='pm-list-item-user' >
                                   
                                   <Grid container className='pm-list-container-avatar-head' >
                                   <Grid item xs={2} sm={2} md={2} lg={2} xl={2} style={{justifyContent:'left'}}  className='pm-list-item-avatar-head'>
                                           <span className='pm-list-item-span-head'>{this.props.dict.settings.tipDocument}</span>
                                       </Grid>
                                  
                                       <Grid item xs={4} sm={4} md={4} lg={4} xl={4} style={{justifyContent:'left'}}  className='pm-list-item-avatar-head'>
                                           <span className='pm-list-item-span-head'>{this.props.dict.settings.nume}</span>
                                       </Grid>
                                       <Grid item xs={3} sm={3} md={3} lg={3} xl={3} style={{justifyContent:'left'}}  className='pm-list-item-avatar-head'>
                                           <span className='pm-list-item-span-head'>{this.props.dict.proiecte.informatiiProiect.dataDoc}</span>
                                       </Grid>
                                       <Grid item xs={1} sm={1} md={1} lg={1} xl={1} style={{justifyContent:'left'}}   className='pm-list-item-avatar-head'>
                                           <span className='pm-list-item-span-head'>{this.props.dict.proiecte.informatiiProiect.stergeDoc}</span>
                                       </Grid>

                                      
                       
                                       
                                      
                                   </Grid>
                                      
                                   </li>
                  
                    {
                        this.state.elementeAfisate.map( (e,idx) =>{
                            return (
                                <li className='pm-list-item-user' key={idx}  >
                                   
                                <Grid container   className='pm-list-container-avatar' style={{justifyContent:'center'}}>
                                
                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2} style={{justifyContent:'left'}} className='pm-list-item-avatar'>
                                           <span className='pm-list-item-span-head'>{e[this.props.onlyColumns.doc_info]}</span>
                                       </Grid>

                                    <Grid style={{justifyContent:'left'}}   item xs={4} sm={4} md={4} lg={4} xl={4}  className='pm-list-item-avatar'>
                                        <span onClick={()=>{this.props.goToFile(e)}}   className='pm-list-item-span'> <i className='material-icons'>description</i> {e[this.props.onlyColumns.nume]}</span>
                                    </Grid>

                                    <Grid style={{justifyContent:'left'}}  item xs={3} sm={3} md={3} lg={3} xl={3}  className='pm-list-item-avatar'>
                                    <span   className='pm-list-item-span'>{e[this.props.onlyColumns.data]}</span>
                                  

                                    </Grid>
                                    <Grid style={{justifyContent:'left'}}  item xs={2} sm={2} md={1} lg={1} xl={1}  className='pm-list-item-avatar'>
                                    
                                            <i className='material-icons' onClick={()=>{this.props.deleteFile(e)}} style={{margin:'auto',
                                                                                fontSize:28,
                                                                                verticalAlign:'middle',
                                                                                color:'#ec4646'}}>delete</i>

                                    </Grid>
                                  
                    
                                    
                                   
                                </Grid>
                                   
                                </li>
                            )
                        })
                    }
                </ul>

            </div>
        );
    }


}// end class


DocumenteList.propTypes={
    elemente:PropTypes.array,
    onlyColumns:PropTypes.object,
    dict:PropTypes.object,
    onElClick:PropTypes.func,
    goToFile:PropTypes.func,
    deleteFile:PropTypes.func,

}